const DpoAgendio = {
    initPripad: function() {
        const tlacitko = $("#tlacitkoAgendioPripad");
        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function(e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    return;
                }
                DpoAgendio.pripad();
            });
    },

    initSmlouva: function() {
        const tlacitko = $("#tlacitkoAgendioOdeslat");
        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function(e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    return;
                }
                DpoAgendio.smlouva();
            });
    },

    postData: function() {
        let postData = {};
        const _ch = $("#_ch");
        if (_ch.length) {
            postData["_ch"] = _ch.val();
        }

        const section = $("#idSection");
        if (section.length && section.val()) {
            postData["idSection"] = section.val();
        }
        const item = $("#idItem");
        if (item.length && item.val()) {
            postData["idItem"] = item.val();
        }

        return postData;
    },

    pripad: function() {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/agendio/pripad";

        const section = $('#idSection');
        if (section.length && section.val()) {
            url += '/' + section.val();
        }
        const item = $('#idItem');
        if (item.length && item.val()) {
            url += '/' + item.val();
        }

        let postData = DpoAgendio.postData();

        $.ajax({
            type: "post",
            url: url,
            data: postData,
            dataType: "json",
            global: true,
            beforeSend: function() {
                Lemo_Alert.closeAll();
                Lemo_Alert.addInfo("Připravuji Agendio případ ...", "agendioPripadBeforeSend");
            },
            complete: function() {
                Lemo_Alert.closeById("agendioPripadBeforeSend");
            },
            success: function(r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true === r.status) {
                    if (r.hasOwnProperty("data")) {
                        const data = r["data"];
                        if (data.hasOwnProperty('agendiosmlouva')) {
                            const elementSmlouva = $("#agendiosmlouva");
                            if (elementSmlouva.length) {
                                elementSmlouva.val(data["agendiosmlouva"]);
                            }
                        }
                        if (data.hasOwnProperty('agendiopripad')) {
                            const elementPripad = $("#agendiopripad");
                            if (elementPripad.length) {
                                elementPripad.val(data["agendiopripad"])
                                elementPripad.trigger('blur')
                            }
                        }
                    }
                }
            },
            error: function() {
                Lemo_Alert.addDanger("Příprava Agendio případu selhala.", "agendioOdeslaniError");
            }
        });
    },

    smlouva: function() {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/agendio/smlouva";

        const section = $('#idSection');
        if (section.length && section.val()) {
            url += '/' + section.val();
        }
        const item = $('#idItem');
        if (item.length && item.val()) {
            url += '/' + item.val();
        }

        let postData = DpoAgendio.postData();

        $.ajax({
            type: "post",
            url: url,
            data: postData,
            dataType: "json",
            global: true,
            beforeSend: function() {
                Lemo_Alert.closeAll();
                Lemo_Alert.addInfo("Připravuji Agendio odeslání ...", "agendioSmlouvaBeforeSend");
            },
            complete: function() {
                Lemo_Alert.closeById("agendioSmlouvaBeforeSend");
            },
            success: function(r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                DynaCore_Item.miniformReload(103, 4);
            },
            error: function() {
                Lemo_Alert.addDanger("Odeslání smlouvy selhalo.", "agendioOdeslaniError");
                DynaCore_Item.miniformReload(103, 4);
            }
        });
    }
};

$(document).ready(function() {
    DpoAgendio.initSmlouva();
    DpoAgendio.initPripad();
});